import React from 'react';
import { CHECKOUT_URL } from '../data/checkout';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg' | 'hero';
  variant?: 'ball' | 'dark';
  className?: string;
};
export function CtaButton({
  children,
  href = CHECKOUT_URL,
  size = 'lg',
  variant = 'ball',
  className = ''
}: CtaButtonProps) {
  const isExternal = href.startsWith('http');
  const sizes = {
    md: 'px-6 py-3.5 text-sm',
    lg: 'px-8 py-5 text-base sm:text-lg',
    hero: 'px-5 py-3.5 text-[13px] leading-tight sm:px-8 sm:py-5 sm:text-lg'
  };
  const variants = {
    ball: 'bg-ball text-court-950 hover:bg-ball-dark',
    dark: 'bg-court-950 text-ball hover:bg-court-800'
  };
  return <a href={href} onClick={() => {
    if (isExternal) {
      trackPixelEvent('InitiateCheckout', {
        content_name: 'Tennis 360 — 12 Volumes + 6 Bonuses',
        value: 27,
        currency: 'USD'
      });
    }
  }} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`inline-flex items-center justify-center rounded-full font-display font-extrabold uppercase tracking-tight text-center
        transition-[transform,background-color,box-shadow] duration-150 ease-smooth
        hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.99]
        focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-ball/50 focus-visible:ring-offset-2 focus-visible:ring-offset-court-950
        shadow-[0_10px_30px_-12px_rgba(0,0,0,0.55)]
        ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-52" data-mp="vddapf42yfam">
      {children}
    </a>;
}